/**
 * Mengenrabatt Upsell (D-20) — the tier selector for sections/qty-upsell-list.liquid
 * (live's legacy-prefixed quantity-discount upsell section, renamed
 * semantically per the naming gate).
 *
 * PRESENTATION ONLY. Live's element carried its own fetch('/cart/add.js');
 * that path is gone. The add itself runs through the standard <product-form>
 * machinery (assets/product-form.js) via a real product form whose hidden
 * quantity input this element keeps in sync — no cart-mutating code lives
 * here (R-01).
 *
 * What this element does, matching live 1:1 where the behaviour is visual:
 *  - radio-style tier selection: toggles the --selected class, swaps the
 *    checkmark into the active circle, records the selected option;
 *  - writes the selected tier's quantity into the form's hidden
 *    [data-qty-upsell-quantity] input;
 *  - mirrors live's three button states (default / "Wird hinzugefügt…" /
 *    "Hinzugefügt!" with a 2s reset) around the product-form submit by
 *    subscribing to the theme's cartUpdate / cartError events, filtered to
 *    this section's variant.
 */
if (!customElements.get('qty-upsell-list')) {
  customElements.define(
    'qty-upsell-list',
    class QtyUpsellList extends HTMLElement {
      connectedCallback() {
        this.options = this.querySelectorAll('.qty-upsell-list__option');
        this.addBtn = this.querySelector('[data-add-to-cart]');
        this.btnText = this.querySelector('[data-btn-text]');
        this.btnLoading = this.querySelector('[data-btn-loading]');
        this.btnSuccess = this.querySelector('[data-btn-success]');
        this.quantityInput = this.querySelector('[data-qty-upsell-quantity]');
        this.form = this.querySelector('form');
        this.variantId = this.dataset.variantId;

        this.selectedOption =
          this.querySelector('.qty-upsell-list__option--selected') || this.options[this.options.length - 1];

        this.options.forEach((option) => {
          option.addEventListener('click', () => this.selectOption(option));
        });

        this._canMirrorStates =
          typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && this.addBtn && this.form;

        if (this._canMirrorStates) {
          this._onSubmit = () => {
            if (this.addBtn.hasAttribute('disabled')) return;
            this.setButtonState('loading');
          };
          this.form.addEventListener('submit', this._onSubmit);

          this._unsubscribeUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (!event || event.source !== 'product-form') return;
            if (String(event.productVariantId) !== String(this.variantId)) return;
            this.setButtonState('success');
            clearTimeout(this._resetTimeout);
            this._resetTimeout = setTimeout(() => this.setButtonState('default'), 2000);
          });

          this._unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
            if (!event || event.source !== 'product-form') return;
            if (String(event.productVariantId) !== String(this.variantId)) return;
            this.setButtonState('default');
          });
        }
      }

      disconnectedCallback() {
        if (this._onSubmit && this.form) this.form.removeEventListener('submit', this._onSubmit);
        if (this._unsubscribeUpdate) this._unsubscribeUpdate();
        if (this._unsubscribeError) this._unsubscribeError();
        clearTimeout(this._resetTimeout);
      }

      selectOption(option) {
        this.options.forEach((opt) => {
          opt.classList.remove('qty-upsell-list__option--selected');
          const circle = opt.querySelector('.qty-upsell-list__radio-circle');
          if (circle) circle.innerHTML = '';
        });

        option.classList.add('qty-upsell-list__option--selected');
        const circle = option.querySelector('.qty-upsell-list__radio-circle');
        if (circle) {
          circle.innerHTML = `<svg class="qty-upsell-list__radio-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
        }

        this.selectedOption = option;

        if (this.quantityInput) {
          this.quantityInput.value = parseInt(option.dataset.quantity, 10) || 1;
        }
      }

      setButtonState(state) {
        if (this.btnText) this.btnText.classList.toggle('hidden', state !== 'default');
        if (this.btnLoading) this.btnLoading.classList.toggle('hidden', state !== 'loading');
        if (this.btnSuccess) this.btnSuccess.classList.toggle('hidden', state !== 'success');
        this.addBtn.classList.toggle('qty-upsell-list__add-btn--success', state === 'success');
      }
    }
  );
}
